import { Maybe } from 'graphql/jsutils/Maybe'
import React, { useMemo } from 'react'

import { SanityGalleryItem } from '../../../graphql/gatsby'
import { getGatsbyImageDataForAsset } from '../../../utils/sanity/image'
import * as Styled from './styled'

interface GalleryItemProps {
  galleryItem: Maybe<SanityGalleryItem>
}

export const GalleryItem: React.FC<GalleryItemProps> = ({ galleryItem }) => {
  const { title, description, image } = galleryItem || {}
  const gatsbyImage = useMemo(() => getGatsbyImageDataForAsset(image, { width: 500 }), [image])

  return (
    <Styled.GalleryItemContainer>
      {!!gatsbyImage && <Styled.ItemImage image={gatsbyImage} alt="" />}
      <div>
        {title && <Styled.ItemTitle>{title}</Styled.ItemTitle>}
        {description && <Styled.ItemDescription>{description}</Styled.ItemDescription>}
      </div>
    </Styled.GalleryItemContainer>
  )
}
